// src/hooks/useAISettings.js
import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const useAISettings = () => {
    const [settings, setSettings] = useState({ enabled: false, loading: true });

    useEffect(() => {
        const docRef = doc(db, 'settings', 'aiAssistant');
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                setSettings({ ...docSnap.data(), loading: false });
            } else {
                setSettings({ enabled: false, loading: false });
            }
        }, (error) => {
            console.error("AI settings fetch error:", error);
            setSettings({ enabled: false, loading: false });
        });

        return () => unsubscribe();
    }, []);

    return settings;
};

export default useAISettings;